module.exports = __webpack_public_path__ + "media/images/admin/icons/arrow-up-right-4b0c4ca14e1f2518756800e68379841b.svg";